import React from 'react';

const e = React.createElement;


function Verify(props) {
  React.Component.constructor.call(this);

  this.validateInput = this.validateInput.bind(this);
}
Verify.prototype = Object.create(React.Component.prototype);


Verify.prototype.render = function() {
  var tr_code = e('p', {key:"10"}, "Je hebt op "+this.props.email+" een 6-cijferige code ontvangen om jouw account te bevestigen.");
  var tr_submit = "opslaan";

  if(this.props.language === "EN") {
    tr_code = e('p', {key:"10"}, "You have received a 6-digit code on "+this.props.email+" to confirm your new account.");
    tr_submit = "submit";
  }

  return e('div', null, e('form', {key:"1", onSubmit:this.validateInput}, [
    tr_code,
    e('div', {key:"11"}, e('input', {type:"text", style:{textAlign:"center"}, value:this.props.verify_code, onChange:this.props.handleChange.bind(this, "verify_code"), placeholder:"654  321", autoFocus:true})),
    e('div', {key:"12"}, e('input', {type:"submit", value:tr_submit, disabled:this.props.verify_is_fetching})),
  ]));
}

Verify.prototype.validateInput = function(e) {
  e.preventDefault();
  var numbers = this.props.verify_code.replace(/\D+/g, '');
  if(numbers.length === 6) {
    this.props.handleVerify(e, numbers);
  }
}


export default Verify



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalAccount_Verify.js
// module id = 233
// module chunks = 1